import Product from "@/utilities/data/model/Product";
import { ProductPartialRootScreenContext } from "../../../../utilities/products/context";
import { BarcodeScannerRootScreen } from "../../../barcode-scanner/screens/BarcodeScannerRootScreen";
import { useAddItem } from "../../utils/sale-controller";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { BarcodeScannerScreenContext } from "../../../barcode-scanner/screens/context";
import React from "react";
import {
  ActionsRootParamList,
  BarcodeScannerRootParamList,
  RegisterRootParamList,
} from "@/types";
import { StackScreenProps } from "@react-navigation/stack";

export type ProductScannerScreenProps = StackScreenProps<
  RegisterRootParamList & BarcodeScannerRootParamList & ActionsRootParamList,
  "ProductScannerScreen"
>;

export const ProductScannerScreen = ({
  navigation,
}: ProductScannerScreenProps) => {
  const { showMessage } = useFlashMessages();

  const addItem = useAddItem({ navigation });

  const primaryAction = async (product: Product) => {
    try {
      await addItem(product.id);
      navigation.pop();
    } catch {
      showMessage({
        message: "Failed to add product to sale",
        severity: "error",
      });
    }
  };

  function handleSuccessfulScan(productId: string) {
    navigation.navigate("ProductRootPartialScreen", {
      screen: "ProductPreviewScreen",
      params: {
        productId,
      },
    });
  }

  return (
    <ProductPartialRootScreenContext.Provider
      value={{
        label: "Add to cart",
        primaryAction,
      }}
    >
      <BarcodeScannerScreenContext.Provider
        value={{
          onNoProductSecondaryAction: {
            label: "Add Custom Product",
            onPress: (barcode: string) => {
              navigation.pop();
              navigation.navigate("ActionsRootScreen", {
                screen: "AddNonMatchedProductScreen",
                params: {
                  barcode: barcode,
                },
              });
            },
          },
        }}
      >
        <BarcodeScannerRootScreen onScanSuccess={handleSuccessfulScan} />
      </BarcodeScannerScreenContext.Provider>
    </ProductPartialRootScreenContext.Provider>
  );
};
